(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uf-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  const initialized = new WeakSet();
  function initialize(root) {
    root.querySelectorAll('[data-uf-footer-disclosure]').forEach(function (details) {
      if (initialized.has(details)) return;
      initialized.add(details);
      const desktop = window.matchMedia('(min-width:768px)');
      function update() { details.open = desktop.matches; }
      update();
      desktop.addEventListener('change', update);
      details.querySelector('summary').addEventListener('click', function (event) {
        if (desktop.matches) event.preventDefault();
      });
      document.addEventListener('shopify:block:select', function (event) {
        if (details.contains(event.target)) details.open = true;
      });
    });
  }
  initialize(document);
  document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uf-home"]) return;
  try {
    
(()=>{
  const init=root=>{
    root.querySelectorAll('[data-uf-brand-slider]').forEach(section=>{
      if(section.dataset.sliderReady)return;
      section.dataset.sliderReady='true';
      const track=section.querySelector('.uf-brand-track');
      const autoplay=section.dataset.autoplay!=='false';
      const speed=Math.max(8,Number(section.dataset.speed)||24)/1000;
      const pauseHover=section.dataset.pauseHover!=='false';
      const items=Array.from(track.children);
      if(!items.length)return;
      const copies=items.map(item=>{
        const copy=item.cloneNode(true);
        copy.removeAttribute('data-shopify-editor-block');
        copy.setAttribute('aria-hidden','true');
        copy.setAttribute('inert','');
        copy.tabIndex=-1;
        track.append(copy);
        return copy;
      });
      const motion=matchMedia('(prefers-reduced-motion: reduce)');
      let hover=false,focused=false,last=0,frame=0,hold=0,position=track.scrollLeft;
      section.addEventListener('pointerenter',()=>hover=true);
      section.addEventListener('pointerleave',()=>hover=false);
      section.addEventListener('focusin',()=>focused=true);
      section.addEventListener('focusout',()=>{requestAnimationFrame(()=>focused=section.contains(document.activeElement))});
      section.addEventListener('pointerdown',()=>hold=performance.now()+5000);
      track.addEventListener('wheel',()=>hold=performance.now()+5000,{passive:true});
      const tick=now=>{
        if(!section.isConnected){cancelAnimationFrame(frame);return}
        const step=Math.min(now-last,50);last=now;
        const span=copies[0].offsetLeft-items[0].offsetLeft;
        if(span>0&&autoplay&&(!hover||!pauseHover)&&!focused&&!motion.matches&&!document.hidden&&now>hold){
          position=(position+step*speed)%span;
          track.scrollLeft=position;
        }else{position=track.scrollLeft}
        frame=requestAnimationFrame(tick);
      };
      frame=requestAnimationFrame(tick);
    });
  };
  init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();

(()=>{
const init=root=>{
root.querySelectorAll('[data-uf-banner-slider]').forEach(slider=>{
if(slider.dataset.bannerReady)return;
slider.dataset.bannerReady='true';
const slides=Array.from(slider.querySelectorAll('.uf-brand-slide'));
const autoplay=slider.dataset.autoplay!=='false';
const interval=Math.max(2000,Number(slider.dataset.interval)*1000||3000);
const pauseHover=slider.dataset.pauseHover!=='false';
if(slides.length<2)return;
const motion=matchMedia('(prefers-reduced-motion: reduce)');
let index=0,timer=0,hover=false,focused=false,visible=true,stopped=false,touch=null,suppressClick=false;
const show=next=>{
const moveFocus=slides[index].contains(document.activeElement);
index=(next+slides.length)%slides.length;
slides.forEach((slide,i)=>{slide.setAttribute('aria-hidden',String(i!==index));slide.inert=i!==index});
if(moveFocus)slides[index].focus({preventScroll:true});
};
const schedule=()=>{
clearTimeout(timer);
if(!autoplay||stopped||(hover&&pauseHover)||focused||!visible||document.hidden||motion.matches||!slider.isConnected)return;
timer=setTimeout(()=>{show(index+1);schedule()},interval);
};
slider.addEventListener('keydown',event=>{
if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();show(index+(event.key==='ArrowRight'?1:-1));schedule()}
if(event.key===' '&&event.target===slider){event.preventDefault();stopped=!stopped;schedule()}
});
slider.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){hover=true;schedule()}});
slider.addEventListener('pointerleave',()=>{hover=false;schedule()});
slider.addEventListener('focusin',()=>{focused=true;schedule()});
slider.addEventListener('focusout',()=>requestAnimationFrame(()=>{focused=slider.contains(document.activeElement);schedule()}));
slider.addEventListener('touchstart',event=>{const p=event.touches[0];touch={x:p.clientX,y:p.clientY};clearTimeout(timer)},{passive:true});
slider.addEventListener('touchend',event=>{
if(!touch)return;
const p=event.changedTouches[0],dx=p.clientX-touch.x,dy=p.clientY-touch.y;
if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.3){suppressClick=true;show(index+(dx<0?1:-1));setTimeout(()=>{suppressClick=false},400)}
touch=null;schedule();
},{passive:true});
slider.addEventListener('touchcancel',()=>{touch=null;schedule()},{passive:true});
slider.addEventListener('click',event=>{if(suppressClick){event.preventDefault();event.stopPropagation()}},true);
slider.addEventListener('shopify:block:select',event=>{const selected=slides.findIndex(slide=>slide===event.target||slide.contains(event.target));if(selected>=0){stopped=true;show(selected);schedule()}});
slider.addEventListener('shopify:block:deselect',()=>{stopped=false;schedule()});
const visibility=()=>{if(!slider.isConnected){clearTimeout(timer);document.removeEventListener('visibilitychange',visibility);return}schedule()};
document.addEventListener('visibilitychange',visibility);
motion.addEventListener('change',schedule);
const observer=new IntersectionObserver(entries=>{if(!slider.isConnected){observer.disconnect();clearTimeout(timer);return}visible=entries[0].isIntersecting;schedule()},{threshold:.15});
observer.observe(slider);
show(0);schedule();
});
};
init(document);
document.addEventListener('shopify:section:load',event=>init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
